import { Link, useLocation } from "react-router-dom";
import { Calculator, ArrowRight } from "@phosphor-icons/react";

/**
 * Mobile-only sticky bottom CTA that appears once the user has scrolled past
 * the hero. Hidden on the calculator page itself. Uses the existing calculator
 * route — does NOT create a new calculator.
 */
export default function StickyCalcCTA() {
  const location = useLocation();
  // Hide on the calculator page and on admin routes
  if (location.pathname.startsWith("/calculator") || location.pathname.startsWith("/admin")) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 z-40 md:hidden"
      data-testid="mobile-sticky-calc"
    >
      <Link
        to="/calculator"
        className="flex items-center justify-center gap-2 bg-gos-navy text-white py-4 rounded-sm shadow-2xl font-semibold text-sm active:scale-[0.98] transition-transform"
      >
        <Calculator size={18} weight="bold" />
        Calculate My Setup Cost
        <ArrowRight size={14} weight="bold" />
      </Link>
    </div>
  );
}
